<template>
  <div class="row app-pagination" style="padding:1rem 0">
    <div class="col-lg-2" v-if="isBatch && batchs.length">
      <div class="batch">
        <b-form-select
          @change="handleBatch"
          v-model="currentOperate"
          class="form-select"
          :options="batchs"
          type="text"
          :disabled="disableBatch"
          placeholder="批量操作"
        ></b-form-select>
      </div>
    </div>

    <div
      class="pull-right"
      :class="[batchs.length ? 'col-lg-10' : 'col-lg-12']"
    >
      <el-pagination
        background
        class="el-app-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="pageSizes"
        :page-size="currentSize"
        :currentPage="currentPage"
        :pager-count="pageCount"
        :layout="layout"
        :total="dataTotal"
        v-if="showPage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    disableBatch: {
      type: Boolean,
      default: false,
    },
    pageCount: { type: Number, default: 5 },
    pageSizes: {
      type: Array,
      default: () => {
        return [30, 50, 100];
      },
    },
    total: {
      type: Number,
      default: 0,
    },
    layout: {
      type: String,
      default: "total,sizes,jumper,prev,pager,next",
    },
    batchs: {
      type: Array,
      default: () => {
        return [];
      },
    },
    pageSize: {
      type: Number,
      default: 30,
    },
    page: { type: Number, default: 1 },
    isBatch: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      currentOperate: 0,
      currentSize: 30,
      totalPages: 0,
      showPage: true,
      dataTotal: 0,
    };
  },
  watch: {
    page() {
      if (this.page) {
        this.currentPage = this.page;
        this.showPage = false;
        this.$nextTick(() => {
          this.showPage = true;
        });
        console.log("currentPage", this.currentPage);
      }
    },
    pageSize() {
      this.currentSize = this.pageSize;
    },
    total() {
      this.dataTotal = this.total;
      this.totalPages = Math.ceil(this.total / this.pageSize);
    },
  },
  beforeMount() {
    this.dataTotal = this.total;
    this.totalPages = Math.ceil(this.total / this.pageSize);
    this.currentSize = this.pageSize;
    this.currentPage = this.page;
  },
  updated() {},
  methods: {
    setPages(page) {
      if (page.pageSize !== undefined) {
        this.currentSize = Number(page.pageSize);
      }
      if (page.page !== undefined) {
        this.currentPage = Number(page.page);
      }
      if (page.total !== undefined) {
        this.dataTotal = Number(page.total);
      }
      if (page.totalPages !== undefined) {
        this.totalPages = Number(page.totalPages);
      }
    },
    // 处理批量操作
    handleBatch(val) {
      console.log("批量操作", val);
      let obj = {
        code: "batch",
        batch: this.currentOperate,
      };
      this.$emit("pageCallback", obj);
      this.currentOperate = "0";
    },
    //分页变化
    handleSizeChange(val) {
      console.log("分页变化", val);
      let obj = {
        code: "pageSize",
        ps: val,
      };
      this.$emit("pageCallback", obj);
    },
    //页码变化
    handleCurrentChange(pageNum) {
      console.log("页码变化", pageNum);
      let obj = {
        code: "page",
        page: pageNum,
      };
      this.$emit("pageCallback", obj);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.app-pagination .batch {
  /*margin-top: 1.5rem !important;*/
  /* padding: 1rem 0; */
}
.app-pagination .batch select {
  max-width: 190px;
  height: 32px;
  line-height: 32px;
  padding: 0px 1.75rem 0px 0.75rem;
}
.app-pagination .pull-right {
  float: right;
}
.app-pagination .el-app-pagination {
  text-align: right;
  /* padding: 1rem 0.75rem; */
}
.app-pagination .el-app-pagination .el-pager li:hover {
  color: #556ee6 !important;
}
.app-pagination .el-pagination.is-background .el-pager li.active {
  color: #fff !important;
}
.app-pagination .el-pagination.is-background .btn-next,
.app-pagination .el-pagination.is-background .btn-prev,
.app-pagination .el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #fff;
  color: #606266;
  min-width: 30px;
  border-radius: 2px;
  border-radius: 50%;
  line-height: 30px;
}
.app-pagination
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #556ee6;
}
</style>
<style scoped>
::v-deep .el-select .el-input {
  height: 30px;
}
::v-deep .el-select input {
  padding: 3px 15px 3px 3px !important;
  height: 28px;
}
::v-deep .batch select {
  height: 28px;
  line-height: 28px;
}
</style>
